import request from '../../constants/fetch';

/**
 * API Get services
 * @returns {Promise<unknown>}
 */
export const getServicesService = (options = {}) =>
    request.get(`/services`, options);

/**
 * API Edit service
 * @returns {Promise<unknown>}
 */
export const editServiceService = (data, options = {}) =>
    request.put(`/services`, data, options);

/**
 * API Add service
 * @returns {Promise<unknown>}
 */
export const addServiceService = (data) =>
    request.post(`/services`, data);

/**
 * API Delete service
 * @returns {Promise<unknown>}
 */
export const deleteServiceService = (id) =>
    request.delete(`/services/${id}`, {});

/**
 * API Get branchs
 * @returns {Promise<unknown>}
 */
export const getBranchsService = (options = {}) =>
    request.get(`/pricing/branch`, options);

/**
* API Edit branch
* @returns {Promise<unknown>}
*/
export const editBranchService = (data, options = {}) =>
    request.put(`/pricing/branch`, data, options);

/**
* API Add branch
* @returns {Promise<unknown>}
*/
export const addBranchService = (data) =>
    request.post(`/pricing/branch`, data);

/**
* API Get languages
* @returns {Promise<unknown>}
*/
export const getLanguagesService = (options = {}) =>
    request.get(`/pricing/language`, options);

/**
* API Edit language
* @returns {Promise<unknown>}
*/
export const editLanguageService = (data, options = {}) =>
    request.put(`/pricing/language`, data, options);

/**
* API Add language
* @returns {Promise<unknown>}
*/
export const addLanguageService = (data) =>
    request.post(`/pricing/language`, data);

/**
 * API Get completion times
 * @returns {Promise<unknown>}
 */
export const getCompletionTimesService = (options = {}) =>
    request.get(`/pricing/completion-time`, options);

/**
* API Edit completion time
* @returns {Promise<unknown>}
*/
export const editCompletionTimeService = (data, options = {}) =>
    request.put(`/pricing/completion-time`, data, options);

/**
* API Add completion time
* @returns {Promise<unknown>}
*/
export const addCompletionTimeService = (data) =>
    request.post(`/pricing/completion-time`, data);

/**
* API Get words
* @returns {Promise<unknown>}
*/
export const getWordsService = (options = {}) =>
    request.get(`/pricing/word`, options);

/**
* API Edit word
* @returns {Promise<unknown>}
*/
export const editWordService = (data, options = {}) =>
    request.put(`/pricing/word`, data, options);

/**
* API Add word
* @returns {Promise<unknown>}
*/
export const addWordService = (data) =>
    request.post(`/pricing/word`, data);

/**
* API Get views
* @returns {Promise<unknown>}
*/
export const getViewsService = (country, options = {}) =>
    request.get(`/dashboard/views?country=${country}`, options);

/**
* API Get annual statistics
* @returns {Promise<unknown>}
*/
export const getAnnualStatisticsService = (options = {}) =>
    request.get(`/dashboard/annualStatistics`, options);